module.exports = __webpack_public_path__ + "img/evidence-img.dac4f95f.png";